// src/components/CepInput.tsx
import React from 'react';
import TextField from '@mui/material/TextField';

// Tipando as propriedades do componente
type Props = {
    value: string | null,
    label: string,
    name: string,
    handleCepChange: (newCep: string) => void;
    disabled: boolean,
    required: boolean,
}



export function CepInput({ value, handleCepChange, disabled, required, label, name }: Props) {
    // Função para tratar o input e formatar o CEP

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let formattedValue = e.target.value;

        // Remove qualquer caractere que não seja número ou traço
        formattedValue = formattedValue.replace(/[^0-9\-]/g, "");

        // Adiciona a formatação do CEP (ex.: 12345-678)
        if (formattedValue.length > 5) {
            formattedValue = formattedValue.replace(/^(\d{5})(\d{3})$/, "$1-$2");
        }

        // Chama a função de onChange com o valor formatado
        handleCepChange(formattedValue);
    };

    return (
        <TextField
            required={required}
            label={label}
            name={name}
            disabled={disabled}
            onChange={onChange}
            size="small"
            inputProps={{ maxLength: 9 }
            } // Limita o tamanho máximo para 10 caracteres
            value={value || ''}
        />
    );
};

export default CepInput;
